import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@/components/ui/skeleton";
interface HistorySkeletonProps {
  // Whether each row shows a leading square thumbnail (image/video studios).
  withThumbnail?: boolean;
  rows?: number;
}

// Loading placeholder for the studio history sidebars while the first page of
// items is being fetched. Mirrors the layout of the real history rows.
export function HistorySkeleton(t0) {
  const $ = _c(6);
  const {
    withThumbnail: t1,
    rows: t2
  } = t0;
  const withThumbnail = t1 === undefined ? false : t1;
  const rows = t2 === undefined ? 6 : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="px-3 py-2"><Skeleton className="h-3 w-16" /></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== rows) {
    t4 = Array.from({
      length: rows
    });
    $[1] = rows;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4 || $[4] !== withThumbnail) {
    t5 = <div className="px-2 py-1" aria-hidden="true">{t3}<div className="space-y-1">{t4.map((_, i) => <div key={i} className="flex items-start gap-2 px-2 py-1.5">{withThumbnail && <Skeleton className="h-8 w-8 shrink-0 rounded" />}<div className="flex-1 space-y-1.5"><Skeleton className="h-3.5 w-[85%]" /><Skeleton className="h-2.5 w-12" /></div></div>)}</div></div>;
    $[3] = t4;
    $[4] = withThumbnail;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}